import { ReactNode } from "react";
import { cn } from "../../../utils/class-names";
import { MainLogo } from "../main-logo";
import { navLink, NavLinkContainer } from "./nav-link";
import { VersionMenu } from "./version-menu";

interface DesktopNavProps {
  className?: string;
  logoLink: ReactNode;
  links: ReactNode;
  protocolMenu: ReactNode;
  rewards: ReactNode;
  wallet: ReactNode;
}

export function DesktopNav({
  className,
  logoLink,
  links,
  protocolMenu,
  rewards,
  wallet,
}: DesktopNavProps): JSX.Element {
  return (
    <header className="flex flex-col gap-10">
      <div className={cn("flex items-center gap-5 justify-between", className)}>
        {logoLink}

        <div className="flex flex-row items-center gap-10">
          <div className="hidden lg:block">{links}</div>

          <div className="flex items-stretch gap-4">
            <VersionMenu />

            {rewards}

            {protocolMenu}

            {wallet}
          </div>
        </div>
      </div>

      <div className="self-end block lg:hidden">{links}</div>
    </header>
  );
}

DesktopNav.LogoLinkContent = MainLogo;
DesktopNav.NavLinkContainer = NavLinkContainer;
DesktopNav.navLink = navLink;
